import type { ElementTweenFunction } from '../types';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { gsap } from 'gsap';

export const fadeInDot: ElementTweenFunction = ({ target,
    options,
    scrollTrigger,
}
) => {

    const duration = options?.duration ? options.duration : .65
    const ease = options?.ease ? options.ease : 'power1.out'

    const tween = gsap.fromTo(
        target,
        { autoAlpha: 0 }, // Start above the viewport, small
        { autoAlpha: 1, duration: duration, ease, }, // Drop down quickly
    )

    if (scrollTrigger?.trigger) {
        ScrollTrigger.create({
            animation: tween,
            ...scrollTrigger,
        });
    }

    return { tween, position: "<60%" };
};
